(() => {
  const shuffle = items => { for (let i = items.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [items[i], items[j]] = [items[j], items[i]]; } return items; };
  function initialize(root) {
    if (root.dataset.rotationReady) return;
    root.dataset.rotationReady = 'true';
    const strip = root.querySelector('[data-rotation-strip]');
    const toggle = root.querySelector('[data-rotation-toggle]');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let pageCount = Math.ceil(Number(root.dataset.count) / 50), pages = [], cards = [], timer, paused = reduced.matches, busy = false;
    const labels = { pause: root.dataset.pause, resume: root.dataset.resume };
    function buttonState() { toggle.setAttribute('aria-pressed', String(paused)); toggle.textContent = paused ? labels.resume : labels.pause; }
    function schedule(delay = Number(root.dataset.interval) || 12000) { clearTimeout(timer); if (!paused) timer = setTimeout(() => { if (document.hidden || root.contains(document.activeElement) || root.matches(':hover')) { schedule(); return; } next(); }, delay); }
    async function load() {
      if (!pages.length) pages = shuffle(Array.from({ length: pageCount }, (_, i) => i + 1));
      const page = pages.shift();
      const url = new URL(root.dataset.feed, location.origin); url.searchParams.set('view', 'krug-feed'); url.searchParams.set('page', page);
      const id = document.body.dataset.krugThemeId;
      if (id && document.body.dataset.krugThemeRole !== 'main') url.searchParams.set('preview_theme_id', id);
      const response = await fetch(url, { credentials: 'same-origin' }); if (!response.ok) throw new Error('feed');
      const dom = new DOMParser().parseFromString(await response.text(), 'text/html');
      const feed = dom.querySelector('[data-krug-product-feed]'); if (!feed) throw new Error('feed');
      pageCount = Number(feed.dataset.pages) || pageCount;
      cards = shuffle([...feed.querySelectorAll('.krug-card-wrap')]);
    }
    async function next() {
      if (busy || !root.isConnected) return;
      busy = true;
      try {
        if (!cards.length) await load();
        if (cards.length) { strip.replaceChildren(...cards.splice(0, 8)); strip.scrollLeft = 0; document.dispatchEvent(new Event('krug:products-updated')); }
        schedule();
      } catch { schedule(60000); }
      finally { busy = false; }
    }
    if (!pageCount) return;
    toggle.hidden = false; buttonState();
    toggle.addEventListener('click', () => { paused = !paused; buttonState(); if (paused) clearTimeout(timer); else schedule(); });
    reduced.addEventListener('change', event => { if (event.matches) { paused = true; buttonState(); clearTimeout(timer); } });
    next();
  }
  document.querySelectorAll('[data-krug-rotating-products]').forEach(initialize);
  document.addEventListener('shopify:section:load', () => document.querySelectorAll('[data-krug-rotating-products]').forEach(initialize));
})();
